import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

/**
 * - 이메일 로그인 화면으로 이동
 * - redirect: 로그인 성공 후 돌아갈 페이지 (웹에서 /login/email?redirect= 로 전달)
 */
export const useMoveToEmailLogin = () => {
  const navigation = useRootStackNavigation();

  return useCallback(
    (redirect?: string) => {
      navigation.push('EmailLogin', redirect ? { redirect } : {});
    },
    [navigation],
  );
};
